import React, { useCallback, useEffect, useRef, useState } from 'react';
import inthetechLogo from '../../assets/logo/inthetechLogo.png';
import './css/login.css';
import '../../styles/core.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';

const ID_CHAR_ONE = /^[A-Za-z0-9._-]$/;
const PW_CHAR_ONE = /^[A-Za-z0-9!@#$%^*()_+\-=]$/;

const filterIdValue = (value) =>
  (value || '')
    .split('')
    .filter((ch) => ID_CHAR_ONE.test(ch))
    .join('')
    .slice(0, 28);

const filterPwValue = (value) =>
  (value || '')
    .split('')
    .filter((ch) => PW_CHAR_ONE.test(ch))
    .join('')
    .slice(0, 32);

function Login() {
  const [manager_id, setManagerId] = useState('');
  const [manager_pw, setManagerPw] = useState('');
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState('');
  const { user, ready, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = location.state?.from?.pathname || '/';
  const justLoggedInRef = useRef(false);

  useEffect(() => {
    if (justLoggedInRef.current) return;
    if (ready && user) navigate(redirectTo, { replace: true });
  }, [ready, user, redirectTo, navigate]);

  const onSubmit = useCallback(async (e) => {
    e.preventDefault();
    if (loading) return;

    setErrMsg('');
    setLoading(true);

    try {
      const loginData = await login({ manager_id, manager_pw });
      justLoggedInRef.current = true;

      const systemNotification = loginData?.systemNotification || {};
      const title = systemNotification.title || '';
      const content = systemNotification.content || '';
      if (title || content) alert(`${title}\n\n${content}`);

      const pwChangedAt = loginData?.userInfo?.pw_changed_at || null;
      if (!pwChangedAt) {
        alert(
          '비밀번호 변경 안내\n\n' +
          '현재 계정은 초기 비밀번호를 사용 중입니다.\n' +
          '보안을 위해 비밀번호를 변경해 주세요.'
        );
      } else {
        const changedDate = new Date(pwChangedAt);
        if (!Number.isNaN(changedDate.getTime())) {
          const diffDays = (Date.now() - changedDate.getTime()) / (1000 * 60 * 60 * 24);
          if (diffDays >= 90) {
            alert(
              '비밀번호 변경 권고\n\n' +
              '마지막 비밀번호 변경일로부터 90일 이상 지났습니다.\n' +
              '계정 보안을 위해 비밀번호를 변경해 주세요.'
            );
          }
        }
      }

      navigate(redirectTo, { replace: true });
    } catch (e2) {
      console.error('login error:', e2);
      console.error('login response:', e2?.response?.data);

      const data = e2?.response?.data || {};
      const code = data.messageCode || e2?.response?.status;
      const serverMessage = data.messageString || data.message || data.error;

      if (code === 401) {
        setErrMsg('로그인 실패: 아이디 또는 비밀번호를 확인하세요.');
      } else if (code === 403) {
        setErrMsg('로그인 실패: 비활성화된 계정입니다.');
      } else if (serverMessage) {
        setErrMsg(`로그인 오류: ${serverMessage}`);
      } else {
        setErrMsg('로그인 중 오류가 발생했습니다.');
      }

      justLoggedInRef.current = false;
    } finally {
      setLoading(false);
    }
  }, [loading, login, manager_id, manager_pw, navigate, redirectTo]);

  return (
    <div>
      <header className="intro">
        <div className="header_wrap">
          <h1 className="intro_logo">
            <a href="#none"><img src={inthetechLogo} alt="로고" /></a>
          </h1>
        </div>
      </header>

      <section id="login_form">
        <div className="int_container">
          <div className="int_wrap">
            <div className="auth-form">
              <h1>로그인</h1>
              <form className="Loginform" onSubmit={onSubmit} autoComplete="on">
                <div className="form-group">
                  <label htmlFor="user_id" className="hide">아이디</label>
                  <div className="inputBox">
                    <input
                      id="user_id"
                      name="username"
                      type="text"
                      placeholder="아이디를 입력하세요"
                      value={manager_id}
                      onChange={(e) => setManagerId(filterIdValue(e.target.value))}
                      autoComplete="username"
                      required
                    />
                  </div>
                </div>

                <div className="form-group mt5">
                  <label htmlFor="user_pass" className="hide">비밀번호</label>
                  <div className="inputBox">
                    <input
                      id="user_pass"
                      name="password"
                      type="password"
                      placeholder="비밀번호를 입력하세요"
                      value={manager_pw}
                      onChange={(e) => setManagerPw(filterPwValue(e.target.value))}
                      autoComplete="current-password"
                      required
                    />
                  </div>
                </div>

                {errMsg && (
                  <div className="form-group mt5" style={{ color: 'crimson' }}>
                    {errMsg}
                  </div>
                )}

                <div className="form-group mt10">
                  <button type="submit" id="btnLogin" className="btn w100 btn_xl" disabled={loading}>
                    {loading ? '로그인 중...' : '로그인'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      <footer id="int_ft" className="sub_ft">
        <div className="int_container">
          <div className="int_wrap">
            <h1 className="ft_logo">
              <a href="#none">
                <img src={inthetechLogo} alt="로고" />
              </a>
            </h1>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Login;
